<div class="accordion" [ngClass]="hostClasses">
  <div class="accordion-header">
    <button type="button" (click)="toggleAccordion()" class="accordion-header-toggle">
      <div class="accordion-header-toggle-container">
        @if (isActive) {
          <span class="material-symbols-outlined">expand_less</span>
        } @else {
          <span class="material-symbols-outlined">expand_more</span>
        }
      </div>

      <div class="order">
        @if (type === 'order') {
          <label for="{{ type }}-{{ number }}">{{ 'order.title' | translate }} #{{ number }}</label>
        }
        @if (type === 'ticket') {
          <label for="{{ type }}-{{ number }}">{{ 'order.ticket.title' | translate }} #{{ number }}</label>
        }
        @if (type === 'invoice') {
          <label class="invoice" for="{{ type }}-{{ number }}">{{ 'order.nf' | translate }} #{{ number }}</label>
        }

        <span class="order-date">{{ totalPrice | currency: 'BRL' : 'symbol' : '1.2-2' : 'pt-BR' }}</span>

        @if (date && type === 'order') {
          <span class="order-date">{{ 'order.createdAt' | translate }}: {{ date }}</span>
        }

        @if (date && type === 'ticket') {
          <span class="order-date">{{ 'order.validation' | translate }} {{ date }}</span>
        }

        <div class="order-right">
          @if (type === 'order') {
            <cx-tag
              [disabled]="status === 'CAN'"
              [type]="getTagType()"
              [variant]="'rounded'"
              [icon]="'check_circle'"
              [iconPosition]="'left'"
              >{{ getStatus() | translate }}</cx-tag
            >
          }

          @if (type === 'ticket') {
            <div class="ticket-options">
              <button (click)="handleDownloadInvoice()" type="button" class="ticket-options-button">
                <span class="material-symbols-outlined">file_copy</span>
                <span>{{ 'order.ticket.code' | translate }}</span>
              </button>
              <button (click)="handleDownloadInvoice()" type="button" class="ticket-options-button">
                <span class="material-symbols-outlined">download</span>
                <span>{{ 'order.ticket.pdf' | translate }}</span>
              </button>
              <button (click)="handleDownloadInvoice()" type="button" class="ticket-options-button">
                <span class="material-symbols-outlined">file_save</span>
                <span>{{ 'order.ticket.xml' | translate }}</span>
              </button>
              <button (click)="handleDownloadInvoice()" type="button" class="ticket-options-button">
                <span class="material-symbols-outlined">share</span>
              </button>

              <cx-tag
                [disabled]="status === 'CAN'"
                [type]="getTagType()"
                [variant]="'rounded'"
                [icon]="'check_circle'"
                [iconPosition]="'left'"
                >{{ getStatus() | translate }}</cx-tag
              >
            </div>
          }

          @if (type === 'invoice') {
            <button (click)="handleDownloadInvoice()" type="button" class="download-invoice-button">
              <span class="material-symbols-outlined">download</span>
            </button>
          }
        </div>
      </div>
    </button>
  </div>

  <div class="accordion-container" [style]="'display:' + (isActive ? 'block' : 'none')">
    <ng-content></ng-content>
  </div>
</div>
